import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ComponentsModule } from 'src/app/components/components.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NouisliderModule } from 'ng2-nouislider';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from 'src/app/interceptors/auth.interceptor';
import { ServerErrorInterceptor } from 'src/app/interceptors/server-error.interceptor';
import { HttpClientModule } from '@angular/common/http';
import { NgOtpInputModule } from 'ng-otp-input';
import { ClipboardModule } from 'ngx-clipboard';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { DatePipe } from '@angular/common';
import { SHARED_PIPES } from '../pipes';
import { LazyLoadImageDirective, SHARED_DIRECTIVES } from '../directives';
import { CarouselModule } from 'primeng/carousel';
import { SHARED_COMPONENTS } from '../components';
import { BlockUIModule } from 'primeng/blockui';
import { QuickQuizComponent } from 'src/app/components/quick-quiz/quick-quiz.component';
import { EncodeImageUriPipe } from '../pipes/encode-image-uri.pipe';
import { PhoneMaskDirective } from '../directives/phone-mask.directive';

const MODULES = [
  CommonModule, RouterModule, ComponentsModule, NgbModule, NouisliderModule, HttpClientModule, NgOtpInputModule,
  ClipboardModule, InfiniteScrollModule, CarouselModule, BlockUIModule, QuickQuizComponent, 
  LazyLoadImageDirective,
  EncodeImageUriPipe,
  PhoneMaskDirective
]

@NgModule({
  imports: [...MODULES],
  declarations: [...SHARED_COMPONENTS, ...SHARED_DIRECTIVES, ...SHARED_PIPES],
  exports: [...MODULES, ...SHARED_COMPONENTS, ...SHARED_DIRECTIVES, ...SHARED_PIPES],
  providers: [
    DatePipe,
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: ServerErrorInterceptor, multi: true}
  ]
})
export class SharedModule {}
